import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { CheckCircle2, Users, Target, TrendingUp, Award } from "lucide-react";

const FoundingPartnerCTA = () => {
  return (
    <section className="py-16 px-8 border-t border-border/20">
      <div className="max-w-[1000px] mx-auto text-center">
        <Badge variant="outline" className="mb-6 text-xs uppercase tracking-wider border-primary/20 text-primary">
          Limited Opportunity
        </Badge>
        <h2 className="text-4xl font-light text-foreground mb-4">
          Founding Partner Program
        </h2>
        <p className="text-lg font-light text-muted-foreground max-w-[700px] mx-auto mb-12">
          We're onboarding our first 10 institutional partners. Join the cohort that defines the future of NIL compliance.
        </p>

        <div className="grid md:grid-cols-2 lg:grid-cols-5 gap-6 mb-12">
          <div className="flex flex-col items-center text-center">
            <div className="w-12 h-12 rounded-full bg-primary/10 flex items-center justify-center mb-3">
              <TrendingUp className="w-6 h-6 text-primary" />
            </div>
            <h4 className="text-sm font-medium text-foreground mb-1">50% Discount</h4>
            <p className="text-xs text-muted-foreground font-light">First year pricing</p>
          </div>
          
          <div className="flex flex-col items-center text-center">
            <div className="w-12 h-12 rounded-full bg-primary/10 flex items-center justify-center mb-3">
              <Users className="w-6 h-6 text-primary" />
            </div>
            <h4 className="text-sm font-medium text-foreground mb-1">Dedicated Team</h4>
            <p className="text-xs text-muted-foreground font-light">Implementation support</p>
          </div>
          
          <div className="flex flex-col items-center text-center">
            <div className="w-12 h-12 rounded-full bg-primary/10 flex items-center justify-center mb-3">
              <Target className="w-6 h-6 text-primary" />
            </div>
            <h4 className="text-sm font-medium text-foreground mb-1">Product Input</h4>
            <p className="text-xs text-muted-foreground font-light">Shape the roadmap</p>
          </div>
          
          <div className="flex flex-col items-center text-center">
            <div className="w-12 h-12 rounded-full bg-primary/10 flex items-center justify-center mb-3">
              <Award className="w-6 h-6 text-primary" />
            </div>
            <h4 className="text-sm font-medium text-foreground mb-1">Case Study</h4>
            <p className="text-xs text-muted-foreground font-light">Co-branded rights</p>
          </div>
          
          <div className="flex flex-col items-center text-center">
            <div className="w-12 h-12 rounded-full bg-primary/10 flex items-center justify-center mb-3">
              <CheckCircle2 className="w-6 h-6 text-primary" />
            </div>
            <h4 className="text-sm font-medium text-foreground mb-1">Lifetime Lock</h4>
            <p className="text-xs text-muted-foreground font-light">Preferred pricing forever</p>
          </div>
        </div>

        <Button
          variant="minimal"
          size="lg"
          onClick={() => window.open("https://cal.com/jay-gauthier-the-mad-jotter-lhon2h/30min?overlayCalendar=true", "_blank")}
          className="h-14 px-12 text-base"
        >
          Request Founding Partner Status
        </Button>
        <p className="text-xs text-muted-foreground/60 mt-4 font-light">
          8 of 10 spots remaining
        </p>
      </div>
    </section>
  );
};

export default FoundingPartnerCTA;
